function c(n) {
  let t = 0;
  for (const o of n) {
    const e = Object.keys(o);
    e.length > t && (t = e.length);
  }
  return t;
}
export {
  c as findMaxContactFields
};
//# sourceMappingURL=index.es805.js.map
